export default {
      id: "shopping_cart-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#shopping_cart",
      toString: function () {
        return this.url;
      }
    }